import { render, staticRenderFns } from "./SlideImagesPopup.vue?vue&type=template&id=dd3e0e7c&scoped=true&"
import script from "./SlideImagesPopup.vue?vue&type=script&lang=js&"
export * from "./SlideImagesPopup.vue?vue&type=script&lang=js&"
import style0 from "./SlideImagesPopup.vue?vue&type=style&index=0&id=dd3e0e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3e0e7c",
  null
  
)

export default component.exports